import api from "./api";

export const settingService = {
  getSetting: (key, defaultValue = "") =>
    api.get("/settings/value", { params: { key, defaultValue } }),
  setSetting: (key, value) =>
    api.put("/settings/value", null, { params: { key, value } }),
  getAnnouncement: () => api.get("/settings/announcement"),
  updateAnnouncement: (payload) => api.put("/settings/announcement", payload),
  getLegalDocuments: () => api.get("/settings/legal"),
  updateLegalDocuments: (payload) => api.put("/settings/legal", payload),
};
